import api from "./helper/client";

export const getAdminStats = async (tenantId: number) => {
    const response = await api.post("/dashboard/admin-stats", { tenant_id: tenantId });
    return response;
};
